import { LitElement, css, html } from 'lit'
import { customElement } from 'lit/decorators.js'

@customElement('one-ux-text')
export class OneUxText extends LitElement {
  static styles = css`
    ::slotted(*) {
      display: none !important;
      visibility: hidden !important;
      position: fixed !important;
      pointer-events: none !important;
    }
  `

  protected render() {
    return html`<slot></slot>`
  }
}
